import { render, staticRenderFns } from "./merchant_car_team_page.vue?vue&type=template&id=a771a8a4&scoped=true"
import script from "./merchant_car_team_page.vue?vue&type=script&lang=js"
export * from "./merchant_car_team_page.vue?vue&type=script&lang=js"
import style0 from "./merchant_car_team_page.vue?vue&type=style&index=0&id=a771a8a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a771a8a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a771a8a4')) {
      api.createRecord('a771a8a4', component.options)
    } else {
      api.reload('a771a8a4', component.options)
    }
    module.hot.accept("./merchant_car_team_page.vue?vue&type=template&id=a771a8a4&scoped=true", function () {
      api.rerender('a771a8a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/merchant/merchant_car_team_page.vue"
export default component.exports